// extracted by mini-css-extract-plugin
export default {"heading_section":"StatusSearch_heading_section__DW0RK","action":"StatusSearch_action__tgkC6","action_reset":"StatusSearch_action_reset__i0CDw"};